var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "icon-stroke",
    stroke: "#0BB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.218 10.905L29.218 27.826 2.782 27.826 2.782 10.905",
    transform: "translate(-335 -263) translate(210 112) translate(53 134) translate(73 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.565 23.652L16.695 23.652 16.695 15.304 5.565 15.304zM19.478 27.826L26.434 27.826 26.434 15.304 19.478 15.304z",
    transform: "translate(-335 -263) translate(210 112) translate(53 134) translate(73 18)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.218 0L2.782 0 0 5.565 32 5.565zM32 6.956c0 3.203-3.84 5.883-6.956 2.783-2.023 3.214-6.482 3.798-9.044.89-2.59 2.946-7.047 2.28-9.043-.89C3.877 12.81 0 10.194 0 6.956v-1.39h32v1.39z",
    transform: "translate(-335 -263) translate(210 112) translate(53 134) translate(73 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.957 9.739L6.957 5.565 8.348 0M16 10.638L16 5.565 16 0M25.044 9.739L25.044 5.565 23.652 0M23.653 21.565c-.384 0-.695.312-.695.696 0 .385.31.695.695.695.384 0 .695-.31.695-.695 0-.384-.311-.696-.695-.696z",
    transform: "translate(-335 -263) translate(210 112) translate(53 134) translate(73 18)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessNew);
export default __webpack_public_path__ + "static/media/business-new.6269beb41957259924206a769d702bf9.svg";
export { ForwardRef as ReactComponent };